export default __webpack_public_path__ + "static/media/banner-icon.d4060aa5.svg";